import { useRuntimeConfig } from 'nuxt/app';
import appConfig from '../env.config.json';
import type { BlockchainConfig } from '~/types/contractAddresses';

type TAppConfig = {
  apiUrl: string;
  wsUrl: string;
  landingUrl: string;
  v2GameUrl: string;
  v2MigrationShutdownAt: string;
  jackpotValue: number;
  jackpotWinPlaces: number;
  flipCoinContract: string;
  pusherContract: string;
  blockchain: BlockchainConfig;
  featureFlags: Record<string, boolean>;
};

export default () => {
  const config = useRuntimeConfig();
  const env = config.public.env as keyof typeof appConfig;

  if (env in appConfig) {
    return appConfig[env as keyof typeof appConfig] as TAppConfig;
  }
  throw Error(`Unknown ENV=${env} environment variable`);
};
